import React, { useState } from "react";

import "./Faq.css";

const Faqs_data = [
  {
    id: 1,
    title: "How do I install CustomerGenius in my Shopify store?",
    desc: "Click Install app in the Shopify App Store, approve the requested permissions, and our onboarding wizard pops up inside Shopify Admin to guide you through threshold settings and a one-time data sync for the past 60 days.",
  },
  {
    id: 2,
    title:
      "Does CustomerGenius start refunding orders the moment I install it?",
    desc: "No. Auto-refund is disabled by default. During onboarding you choose your auto-refund thresholds. You can either manually review the orders for some time to see how it works, or turn on auto-refunding from the start.",
  },
  {
    id: 3,
    title: "What signals feed the fraud-score?",
    desc: "We compare every new order’s email, phone number, billing + shipping addresses (fuzzy and exact), and name against prior orders that used the same discount. Each matching field adds points to the score.",
  },
  {
    id: 4,
    title: "What exactly happens when an order is refunded?",
    desc: "We issue a full refund via the Shopify API, and (optionally) send you and the customer an email alert. If you use Recharge or Shipstation, as long as you connect them in the settings tab, they will also be cancelled there.",
  },
  {
    id: 5,
    title: "Will this slow down my checkout?",
    desc: "No. We process orders post-checkout via Shopify’s webhooks, so your storefront performance is unaffected.",
  },
  {
    id: 5,
    title: "Is there a free trial or free tier?",
    desc: "Yes, there is a 14-day trial for all tiers. We currently do not offer a free tier at this time, but you're welcome to use the trial to determine whether there is enough fraud to justify the price.",
  },
  {
    id: 6,
    title: "How do I get help if something looks wrong?",
    desc: "Email support@customergenius.io.",
  },
];

export default function Faq({ id }) {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div id={id} className="section py-constant">
      <div className="container">
        <div className="subtitle">FAQ</div>

        <h2 className="h2 title center">
          Frequently
          <span className="accent"> Asked Questions</span>
        </h2>

        <div className="accordions">
          {Faqs_data.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.id}
                className={`accordion-item ${isOpen ? "active" : ""}`}
              >
                <div
                  className="acc-title cursor-pointer flex justify-between items-center"
                  onClick={() => toggleAccordion(index)}
                >
                  <span>{item.title}</span>
                  <span className="icon">{isOpen ? "−" : "+"}</span>
                </div>
                {isOpen && <div className="content mt-2">{item.desc}</div>}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
